/**
 * The LayerHost is a div which is created in place
 * where you want to "house" a portaled content
 */
import { forwardRef } from 'preact/compat';
import { baseStyle } from './themes/LayerHostStyles.css';

const LayerHost = forwardRef<HTMLDivElement>((_props, ref) => {
  return <div id="__root_layer_host" role="presentation" ref={ref} class={baseStyle} />;
});

LayerHost.displayName = 'Forwarded<LayerHost>';

export default LayerHost;
